import React from "react";
import TitleLogo from "../assets/img/title_logo.png";
import {Redirect} from 'react-router-dom'

function AfterEventMessage() {
    const [width, setWidth] = React.useState(window.innerWidth * 0.6);
    const [fontSize, setFontSize] = React.useState(window.innerWidth * 0.04);
    let isAuth = localStorage.getItem('user')
    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 900) {
                setWidth(window.innerWidth * 0.6)
                setFontSize(window.innerWidth * 0.04)
            } else {
                setWidth(window.innerWidth * 0.5)
                setFontSize(window.innerWidth * 0.04)
            }
        }

        window.addEventListener('resize', handleResize)
    })

    return (
        <div className="countdown-container">
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <div>
                    <img alt={''} src={TitleLogo} style={{width: width * 0.7, height: 'auto', marginTop: '1vw'}}/>
                </div>
                <div>
                    <p style={{color: 'white', fontSize: '2.1vw', marginTop: '8.1vw'}}>
                        The event content will be available on-demand from 27th November 2020.
                    </p>
                    <p style={{color: 'white', fontSize: '2.1vw', marginTop: '1.5vw'}}>
                        More details to follow.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AfterEventMessage;
